<div class="copy-tooltip">
    @if (isCopySuccess()) {
        <div class="copy-tooltip_success-copy" (click)="onCopyClick($event)">
            <svg class="copy-tooltip_success-copy-icon">
                <use xlink:href="#approve"></use>
            </svg>
            <span>{{'components.copy.copy_success_short' | l10n}}</span>
        </div>
    } @else {
        <div class="copy-tooltip_copy" (click)="onCopyClick($event)">
            <svg class="copy-tooltip_copy-icon">
                <use xlink:href="#copy"></use>
            </svg>
        </div>
    }
</div>
